<template>
    <div class="w-10 mr-2 mb-2">
        <div class="color-preset" @click="$emit('click')">
            <div class="foreground-color" :style="{'background-color': color}"></div>
            <div class="background-color" :style="{'background-color': background}"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: String,
        background: String
    },
    data() {
        return {
            color: this.wave,
            background: this.background
        }
    },
    computed: {
        // isSelected() {
        //     return this.$store.state.soundFiles
        // }
    },
};
</script>
